import _classCallCheck from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import FirebaseBaseSessionAsync from "./FirebaseBaseSessionAsync";
import * as log from "loglevel";
import { deleteApp } from "firebase/app";
import { off } from "firebase/database";

var FirebaseConversationSessionAsync = /*#__PURE__*/function (_FirebaseBaseSessionA) {
  _inherits(FirebaseConversationSessionAsync, _FirebaseBaseSessionA);

  function FirebaseConversationSessionAsync(userName, conversationName, id) {
    var _this;

    _classCallCheck(this, FirebaseConversationSessionAsync);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FirebaseConversationSessionAsync).call(this, id));
    _this.conversationName = conversationName;
    _this.userName = userName;
    return _this;
  }

  _createClass(FirebaseConversationSessionAsync, [{
    key: "attachConversationListener",
    value: function attachConversationListener(conversationListener) {
      var _this2 = this;

      log.trace("attach conversation listener");
      this.addNodeUpdateListener("ce", this.conversationName, function (snapshot) {
        conversationListener(_this2.convertSnapshotToConversationEvent(snapshot));
      });
    }
  }, {
    key: "detachListener",
    value: function detachListener() {
      off(this.getReference("ce", this.conversationName));
      var firebaseApp = this.getFirebaseApp();
      deleteApp(firebaseApp);
    }
  }, {
    key: "convertSnapshotToConversationEvent",
    value: function convertSnapshotToConversationEvent(snapshot) {
      var snapshotValue = snapshot.val();

      if (snapshotValue == null) {
        return snapshotValue;
      }

      var event = {};
      event.type = snapshotValue.t;

      if (snapshotValue.t === "MESSAGE") {
        event.content = {
          id: snapshotValue.c.i,
          type: snapshotValue.c.y,
          details: snapshotValue.c.d,
          message: snapshotValue.c.m,
          messageMetadata: snapshotValue.c.a,
          username: snapshotValue.c.u,
          timestamp: snapshotValue.c.t,
          resource: snapshotValue.c.r
        };
      } else if (snapshotValue.t === "LAST_READ_UPDATE") {
        event.content = {
          username: snapshotValue.c.u,
          timestamp: snapshotValue.c.t
        };
      } else if (snapshotValue.t === "UPDATE_MESSAGE") {
        event.content = {
          id: snapshotValue.c.i,
          message: snapshotValue.c.m,
          messageMetadata: snapshotValue.c.a,
          username: snapshotValue.c.u,
          timestamp: snapshotValue.c.t
        };
      } else if (snapshotValue.t === "DELETE_MESSAGE") {
        event.content = {
          id: snapshotValue.c.i,
          conversationName: snapshotValue.c.cn
        };
      }

      return event;
    }
  }]);

  return FirebaseConversationSessionAsync;
}(FirebaseBaseSessionAsync);

export { FirebaseConversationSessionAsync as default };